import React from 'react'

import { Avatar, Table } from 'antd'
import { useDeepEffect } from '../../../../utils/hooks'
import { isEmpty } from 'lodash'
import { useDispatch, useSelector } from 'react-redux'
import {
  fetchHeroFollowerList,
} from '../../../../modules/heroLink'
import { HeroType } from '../../../../config'

export const HeroFollower = ({ data }) => {
  const dispatch = useDispatch()

  const { heroFollowerList } = useSelector(
    (state) => ({
      heroFollowerList: state.heroLink.heroFollowerList.heroLinkFollowerDtoList
    }),
    []
  )
  const columns = [
    {
      title: '',
      dataIndex: 'image',
      key: 'image',
      render: (name, row) => (
        <Avatar src={row.image} />
      )
    },
    {
      title: 'Name',
      dataIndex: 'heroName',
      key: 'heroName'
    },
    {
      title: 'Hero Type',
      dataIndex: 'heroType',
      key: 'heroType',
      render: (name, row) => {
        return <div>{HeroType[name] ? HeroType[name].title : '-'}</div>
      }
    },
  ]

  function fetch() {
    dispatch(fetchHeroFollowerList(data.id))
  }

  useDeepEffect(() => {
    if (!isEmpty(data)) {
      fetch()
    }
  }, [data])

  return (
    <Table
      rowKey={(record) => record.id}
      dataSource={heroFollowerList}
      columns={columns}
    />
  )
}

export default HeroFollower



// WEBPACK FOOTER //
// ./src/pages/Heroes/components/HeroFollower/index.js